<div class="fm-centered-popup-backdrop"></div>
<div class="fm-centered-popup">
  <div class="row align-items-center justify-content-center">
    <div class="w-100"></div>
    <div class="col-auto px-0 row align-items-center">
        <mat-spinner [diameter]="55"></mat-spinner>
    </div>
  </div>
</div>
